import { useState } from "react";
import { showToast } from "../components/toast";
import axios from "axios";
import { API_URL } from "../config";

const AddCreditsPopup = ({ onClose, dropdownOptions, fetchSubscriptions }) => {
  const token = localStorage.getItem("authToken");

  const [creditData, setCreditData] = useState({
    serviceid: "",
    status: "",
    stype: "",
    credits: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleCreditInputChange = (e) => {
    const { name, value } = e.target;
    setCreditData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleCreditAdd = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Lookup names for status and stype
    const selectedStatus = dropdownOptions.serviceStatusList.find(
      (item) => item.id == creditData.status
    );
    const selectedStype = dropdownOptions.subscriptionTypeList.find(
      (item) => item.id == creditData.stype
    );

    const payload = {
      serviceid: Number(creditData.serviceid), 
      status: selectedStatus?.pick_name || "", 
      stype: selectedStype?.pick_name || "", 
      credits: Number(creditData.credits), 
      jsondata: "name=John&email=john@example.com", 
    };

    try {
      const response = await axios.post(
        `${API_URL}subscription/save-credits-popup`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        showToast.success("Credits Added Successfully");
        setTimeout(() => onClose(), 2000);
        fetchSubscriptions();
      } else {
        showToast.error(response.data.message || "Failed to add service");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
          <div className="modal-content">
            <div className="modal-header">
              <div className="col-md-11">
                <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                  Add Credits
                </h5>
              </div>
              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
              >
                &times;
              </button>
              <div className="clearfix"></div>
            </div>
            <div className="modal-body">
              <form onSubmit={handleCreditAdd} className="form-horizontal">
                <div className="panel-body">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label>Service</label>
                      <select
                        name="serviceid"
                        value={creditData.serviceid}
                        onChange={handleCreditInputChange}
                        className="form-control"
                        required
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.serviceList &&
                          dropdownOptions.serviceList.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.service_name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label>Service Type</label>
                      <select
                        name="stype"
                        value={creditData.stype}
                        onChange={handleCreditInputChange}
                        className="form-control"
                      >
                        <option value="">- select -</option>
                        {dropdownOptions.subscriptionTypeList &&
                          dropdownOptions.subscriptionTypeList.map(
                            (item, index) => (
                              <option key={index} value={item.id}>
                                {item.pick_name}
                              </option>
                            )
                          )}
                      </select>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label>Status</label>
                      <select
                        name="status"
                        value={creditData.status}
                        onChange={handleCreditInputChange}
                        className="form-control"
                      >
                        <option value="">- select -</option>
                        {dropdownOptions.serviceStatusList &&
                          dropdownOptions.serviceStatusList.map(
                            (item, index) => (
                              <option key={index} value={item.id}>
                                {item.pick_name}
                              </option>
                            )
                          )}
                      </select>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label>Credits</label>
                      <input
                        type="text"
                        name="credits"
                        value={creditData.credits}
                        onChange={handleCreditInputChange}
                        placeholder="Credits"
                        className="form-control"
                      />
                    </div>
                    <div
                      className="col-md-12 mt-2"
                      style={{ textAlign: "right" }}
                    >
                      <button
                        type="submit"
                        className="btn btn-primary mx-2"
                        disabled={isLoading}
                      >
                        {isLoading ? "Submitting..." : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCreditsPopup;
